import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import type { FieldBaseProps } from './types';

export interface FieldTextProps<T extends FieldValues> extends FieldBaseProps<T> {
  placeholder?: string;
  type?: 'text' | 'email' | 'password' | 'tel' | 'url';
  multiline?: boolean;
  rows?: number;
}

/** RHF-bound single-line (or multiline) text field. */
export function FieldText<T extends FieldValues>({
  control,
  name,
  label,
  helperText,
  required,
  disabled,
  placeholder,
  type = 'text',
  multiline = false,
  rows = 3,
}: FieldTextProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          size="small"
          value={field.value ?? ''}
          label={label}
          placeholder={placeholder}
          type={type}
          multiline={multiline}
          rows={multiline ? rows : undefined}
          required={required}
          disabled={disabled}
          fullWidth
          error={!!fieldState.error}
          helperText={fieldState.error?.message ?? helperText}
        />
      )}
    />
  );
}
